// extracted by mini-css-extract-plugin
export var deleteModal = "_gc-0";